<template>
  <unroll-element
    :title="stringified_dict(metavariables_poid)"
    :available="boruta_instantiated"
    :start_opened="boruta_instantiated"
  >
    <div v-if="boruta_instantiated">
      <boruta-chart
        v-if="!_.isUndefined(boruta_colnames) && boruta_colnames.length !== 0"
        key="caruana_iterations_chart"
        :project_id="project_id"
        :tracking_infos="boruta_tracking_info"
        :colnames="boruta_colnames"
        :title="$t('feature_importance_for_boruta')"
      />

      <b-table
        responsive
        striped
        hover
        :items="boruta_imp_history_table_items"
        :fields="boruta_colnames_table_fields"
        class="synaplus-cosmo-scroll-higher-720"
      >
        <template
          v-for="colname in boruta_colnames"
          :slot="colname"
          slot-scope="data"
        >
          <span>{{ data.value }}</span>
        </template>
      </b-table>

      <boruta-bar-chart
        v-if="!_.isUndefined(boruta_colnames) && boruta_colnames.length !== 0"
        key="caruana_hits_chart"
        :project_id="project_id"
        :tracking_infos="boruta_tracking_info"
        :colnames="boruta_colnames"
        :title="$t('importance_hits')"
      />

      <b-table
        responsive
        striped
        hover
        :items="boruta_cols_status_items"
        :fields="boruta_cols_status_fields"
        class="synaplus-cosmo-scroll-higher-720"
      >
        <template
          v-for="colname in boruta_colnames"
          :slot="colname"
          slot-scope="data"
        >
          <i :class="data.value" />
        </template>
      </b-table>
      <!--       <b-table
        responsive
        striped
        hover
        :items="boruta_cols_status_items"
        :fields="boruta_cols_status_fields"
        class="synaplus-cosmo-scroll-higher-720"
      >
        <template #cell()="data">
          <i :class="data.value" />
        </template>
      </b-table> -->
    </div>
  </unroll-element>
</template>

<i18n>
{
  "en": {
    "feature_importance_for_boruta": "Feature importance for Boruta iterations",
    "importance_hits": "Importance hits"
  },
  "fr": {
    "feature_importance_for_boruta": "Importance des features pour les itérations de Boruta",
    "importance_hits": "Importance relative des features"
  }
}
</i18n>

<script>
import _ from 'lodash'

import {
  brick_mixin,
  subscription_mixin,
  metavariables_tracking_info_mixin,
  brick_generic_modelgenerator_tracking_info_mixin,
} from '@/components/mixin.js'

import { round_value } from '@/utils.js'

import UnrollElement from './unroll_element.vue'
import BorutaChart from './boruta_chart.vue'
import BorutaBarChart from './boruta_bar_chart.vue'

// *****************************************************************************

export default {
  name: 'BrickGenericModelgeneratorSubcomponentBoruta',
  components: {
    UnrollElement,
    BorutaChart,
    BorutaBarChart,
  },

  mixins: [
    brick_mixin,
    subscription_mixin,
    metavariables_tracking_info_mixin,
    brick_generic_modelgenerator_tracking_info_mixin,
  ],
  props: ['brick_id', 'project_id', 'metavariables_poid'],
  data() {
    return {}
  },

  computed: {
    _() {
      return _
    },

    boruta_colnames() {
      return this.boruta_tracking_info.colnames || []
    },

    imp_hits() {
      return this.boruta_tracking_info.imp_hits || []
    },

    imp_history() {
      return this.boruta_tracking_info.imp_history || []
    },

    boruta_colnames_table_fields() {
      const res = []

      const field = {
        key: 'boruta_iter_nb',
        label: 'Iteration',
        class: 'text-center',
        variant: 'primary',
      }
      res.push(field)

      for (const colname of this.boruta_colnames) {
        const field = {
          key: colname,
          label: _.capitalize(colname),
          class: 'text-center',
        }
        res.push(field)
      }

      return res
    },

    boruta_imp_history_table_items() {
      const res = []

      for (const boruta_k in this.imp_history) {
        const imps = this.imp_history[boruta_k]
        const hits = this.imp_hits[boruta_k] || []

        const item = {}
        item._cellVariants = {}
        item.boruta_iter_nb = boruta_k
        for (const col_i in imps) {
          const name = this.boruta_colnames[col_i]
          const imp = imps[col_i]
          const hit = hits[col_i]

          let color = null
          let content = null
          if (!isNaN(imp)) {
            content = round_value(imp)
          } else {
          }
          if (hit === 1) {
            color = 'success'
          }
          item._cellVariants[name] = color
          item[name] = content
        }

        res.push(item)
      }

      return res
    },

    boruta_cols_status_fields() {
      const res = []

      const field = {
        key: 'line_title',
        label: '',
        class: 'text-center',
        variant: 'primary',
      }
      res.push(field)

      for (const colname of this.boruta_colnames) {
        const field = {
          key: colname,
          label: _.capitalize(colname),
          class: 'text-center',
        }
        res.push(field)
      }

      return res
    },

    // boruta_cols_status_items() {
    //   const res = []

    //   const status_per_iter = this.boruta_tracking_info.cols_status || []
    //   const nb_iters = status_per_iter.length
    //   const cur_status = status_per_iter[nb_iters - 1] || []

    //   const item = {}
    //   item._cellVariants = {}
    //   item.line_title = 'Status'
    //   for (const col_k in cur_status) {
    //     const name = this.boruta_colnames[col_k]
    //     const s = cur_status[col_k]
    //     let klass = null
    //     let color = null
    //     if (s === 1) {
    //       klass = 'fas fa-check-circle text-success'
    //     } else if (s === 0) {
    //       klass = 'fas fa-question-circle'
    //     } else if (s === -1) {
    //       color = 'danger'
    //       klass = 'fas fa-times-circle text-danger'
    //     }
    //     item._cellVariants[name] = color
    //     item[name] = klass
    //   }

    //   res.push(item)

    //   return res
    // },
    boruta_cols_status_items() {
      const res = []

      const status_per_iter = this.boruta_tracking_info.cols_status || []
      const nb_iters = status_per_iter.length
      const cur_status = status_per_iter[nb_iters - 1] || []

      const item = {}
      item._cellVariants = {}
      item.line_title = 'Status'
      for (const col_k in cur_status) {
        const name = this.boruta_colnames[col_k]
        const s = cur_status[col_k]
        let klass = null
        let color = null
        if (s === 1) {
          klass = 'fas fa-check-circle text-success'
        } else if (s === 0) {
          klass = 'fas fa-question-circle'
        } else if (s === -1) {
          color = 'danger'
          klass = 'fas fa-times-circle text-danger'
        }
        item._cellVariants[name] = color
        item[name] = klass
      }

      res.push(item)

      return res
    },

    boruta_instantiated() {
      return !_.isEmpty(this.boruta_tracking_info)
    },
  },
  watch: {
    boruta_instantiated: {
      immediate: true,
      handler(nv, ov) {
        if (!_.isEqual(nv, ov)) {
          if (nv) {
            this.$emit('is_instantiated')
          }
        }
      },
    },
  },
}
</script>
